import * as Tgcc from '../tgccGlobal';
import * as React from 'react';
import {CSSProperties} from 'react';
import {InjectedRouter} from 'react-router';



interface DesignProps {
    title: any;
    router?: InjectedRouter;
    design?: any;
    children?: any;
    containerHeight?:string;
    containerWidth?:string;
    innerHeight?:string;
    innerWidth?:string;
    margin?:string;
    fontFamily?:string;
}

export class CampusProofCard extends React.Component<DesignProps, any> {

    cardStyle: CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        backgroundColor: '#E9E6E6',
        margin: '15px 10px',
        paddingTop: '20px',
        borderRadius: '15px',
        height: '390px',
        width: '340px',
    }

    iconStyle: CSSProperties = {
        backgroundColor: 'transparent',
        marginTop: '7px',
        height: '17px',
        display: 'flex',
    }

    contentStyle: CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        height: '330px',
        width: '304px',
        margin: '0px auto',
        backgroundColor: 'rgb(255, 255, 255)',
        borderRadius: '15px',
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: '5px',
        alignItems:'center'
    }
    titleStyle : CSSProperties = {
        textAlign:'center',
        fontFamily:'BarlowMedium',
        color:'#616060',
        position:'relative',
        bottom:'18px',
        letterSpacing:'2px'
    }

    props: DesignProps;

    constructor(props: DesignProps){
        super(props);
        this.props = props;
        this.cardStyle.height = this.props.containerHeight || this.cardStyle.height;
        this.contentStyle.height = this.props.innerHeight || this.contentStyle.height;
        this.cardStyle.width = this.props.containerWidth || this.cardStyle.width;
        this.contentStyle.width = this.props.innerWidth || this.contentStyle.width;
        this.cardStyle.margin = this.props.margin || this.cardStyle.margin;
        this.titleStyle.fontFamily = this.props.fontFamily || this.titleStyle.fontFamily;
        
    }

    render() {
        return (
            <div style={this.cardStyle}>
                <div style={this.titleStyle}>{this.props.title}</div>
                <div style={this.contentStyle}>
                    {this.props.children}
                </div>
            </div>
        );
    }

}
